/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cover-box[_ngcontent-%COMP%]{margin-top:100px}.portEntry[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;margin-top:120px;max-height:450px;height:100%}"];
export { styles as styles };
